module.exports = __webpack_public_path__ + "static/img/programme-bg.523885a3.png";